import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Partitioning } from '@classes/partitioning';
import { SimulationVisibilityType } from '@enums/simulation-visibility-type.enum';
import { SimulationService } from '@services/simulation.service';
import { OriginService } from '@services/origin.service';
import { Origin } from '@classes/origin/origin';
import { OriginYear } from '@classes/origin/origin-year';
import { UserService } from '@services/user.service';
import { ProviderType } from '@enums/provider-type.enum';
import { AmountStageCode } from '@enums/amount-stage-code.enum';

@Component({
    selector: 'app-simulations',
    templateUrl: './simulations.component.html',
    styleUrls: ['./simulations.component.scss']
})
export class SimulationsComponent implements OnInit, OnDestroy {
    private partitioningsListSub: Subscription;
    private userParametersSub: Subscription;

    partitioningsList: Partitioning[];
    visibilityType = SimulationVisibilityType;
    years: OriginYear[];
    userOrigin: Origin;
    providerType = ProviderType;
    isMJP: boolean;

    constructor(
        private simulationSrv: SimulationService,
        private originSrv: OriginService,
        private userSrv: UserService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.originSrv.get()
        .subscribe(origin => {
            this.years = origin.lastYears.sort((a, b) => a.year - b.year);
        });

        this.userParametersSub = this.userSrv.userParametersSubject
        .subscribe(userParams => {
            if(userParams) {
                this.userOrigin = userParams.origin;
                this.isMJP = this.userOrigin.selectedLastYear.amountStageCode === AmountStageCode.mjp;
            } else {
                this.userSrv.getParameters().subscribe();
            }
        });

        this.simulationSrv.getPartitioningsList()
        .subscribe(partsList => {
            this.partitioningsList = partsList;
        });

        this.partitioningsListSub = this.simulationSrv.partitioningListChanged
        .subscribe(partsList => {
            this.partitioningsList = partsList;
        });
    }

    ngOnDestroy() {
        if(this.partitioningsListSub) {
            this.partitioningsListSub.unsubscribe();
        }
        if(this.userParametersSub) {
            this.userParametersSub.unsubscribe();
        }
    }
}
